import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Field, inputCls } from "../components/landing/Field";
import { useAuth } from "../context/AuthContext";
import { errorMessage } from "../lib/api";
import { ADMIN_PATH } from "../constants/adminRoutes";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={ADMIN_PATH} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate(ADMIN_PATH);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B1120] px-4 font-body">
      <form onSubmit={onSubmit} data-testid="admin-login-form" className="w-full max-w-md space-y-6 border border-white/10 bg-[#1E293B]/60 p-8">
        <div className="flex items-center gap-3">
          <div>
            <h1 className="font-heading text-2xl font-extrabold text-white">Team login</h1>
            <p className="text-sm text-slate-400">Balangir Group lead admin</p>
          </div>
        </div>
        <Field label="Email">
          <Input type="email" required autoComplete="username" data-testid="admin-login-email-input" className={inputCls}
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password">
          <Input type="password" required autoComplete="current-password" data-testid="admin-login-password-input" className={inputCls}
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit-button"
          className="flex h-12 w-full items-center justify-center gap-2 bg-orange-500 font-semibold text-white transition-colors hover:bg-orange-600 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Sign in
        </button>
        <a href="/" data-testid="admin-login-back-link" className="block text-center text-sm text-slate-500 hover:text-slate-300">Back to website</a>
      </form>
    </div>
  );
}
